import styled from 'styled-components';

export const StyledMintActionFigures = styled.div `
  width: 100%;
  height: calc(100vh - 80px);
  max-height: calc((100vw * 9 / 16));
  padding-bottom: 10px;
  display: grid;
  flex-direction: column;
  color: white;
  font-size: 36px;
  background: ${({ theme }) => theme.mintBackground};
  
  > * {
    grid-column-start: 1;
    grid-row-start: 1;
  }

  .third-line {
    width: 100%;
    padding: 20px 0px;
    margin: 0px;
    text-align: justify;
    text-align-last: justify;
    color: ${({theme}) => theme.mintGreen};
    font-size: 34px;
    font-weight: bold;
    letter-spacing: 5px;
    line-height: 36px;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    height: 100%;
    max-height: 100%;
  }
}
`

export const Header = styled.div`
  width: 100%;
  max-height: 25%;
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: 1vh;
  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 20px;
  }
`

export const HeaderImage = styled.img`
  display: flex;
  height: 100%;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 100%;
  }
`

export const Content = styled.div`
  // border: 10px dotted lime;
  height: 100%;
  width: 100%;  
  height: 100%;
  display: grid;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    display: flex;
  }
`

export const Main = styled.div`
  // borer: 5px dotted red;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    flex-direction: column;    
  }
`

export const MidContent = styled.div`
  // border: 10px dotted magenta;
  width: 100%;
  max-width: calc((100vh - ${({theme}) => theme.navHeight}) * 16 / 9);
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(20, 5%);

  > * {
    // border: 4px dotted magenta;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(27, 1fr);    
  }
`

export const PanelContainer = styled.div`
  // border: 5px dotted pink;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Panel = styled.div`
  // border: 5px dashed white;
  display: flex;
  // flex-basis: 1%;
  width: 100%;
  max-height: 20%;
  background-size: contain;
`

export const PanelImage = styled.img`
  width: 100%;
`

export const MapRoot = styled.div`
  // border: 5px dashed orange;
  display: grid;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  grid-column: 1;
  grid-row: 4 / 18;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(14, 1fr);

  > * {
    grid-column-start: 1;
    grid-row-start: 1;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 12px;
    grid-column: 1;
    grid-row: 14 / 28;
  }
`

export const MapHolder = styled.div`
  display: block;
  grid-column: 1;
  grid-row: 1 / 12;
  background: url("/assets/map_cropped.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`

export const R = styled.img`
  max-width: 20%;
  max-height: 20%
  margin-left: 10px;
`

export const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
`

export const MapWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-column: 1;
  grid-row: 1 / 15;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(14, 1fr);
  gap: 4px;
`

export const MapOverlay = styled.div`
  background: transparent;
  width: 100%
  height: 100%;
  background: url("/assets/map_net_overlay.png");
  background-size: cover;
  grid-column: 1;
  grid-row: 1 / 14;
`

export const SoldiersContainer = styled.div`
  width: 100%;
  height: 100%;  
  display: grid;
  grid-template-columns: repeat(20, 1fr); /* Three equal-width columns */
  grid-template-rows: repeat(20, 1fr); /* Adjust rows as needed */
`

export const Soldier = styled.div`
  
  background: url("/assets/soldier_icon.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  grid-column: ${({theme, $column}) => $column};
  grid-row: ${({theme, $row}) => $row};  
`

export const MidContainer = styled.div`
  // border: 5px dashed red;
  display: grid;
  width: 100%;
  font-family: "BebasNeue";
  grid-column: 2;
  grid-row: 6 / 19;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(13, 1fr);

  > * {
    // border: 5px dotted white;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    grid-column: 1;
    grid-row: 1 / 14;
    padding: 12px;    
  }  
`

export const MidHeader = styled.div`
  display: grid;
  grid-column; 1;
  grid-row: 1 / 3;
  background: url("/assets/solarpunk_header.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    background-size: cover;
  }  
`

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column; 1;
  grid-row: 3 / 5;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 5px 10px;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    background-size: cover;
    padding: 0px 0px;
  }  
`

export const PanelHolder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

`
export const Delimiter = styled.div`
  width: 100%;
  height: 3px;
  background: white;
`

export const Price = styled.div`
  display: inline;
  width: 100%;
  margin: 0px;
  text-align: justify;
  text-align-last: justify;
  color: ${({theme}) => theme.mintGreen};
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 3px;
  line-height: 1;
  text-transform: uppercase;

  @media (max-width: 3300px) {
    font-size: 2.8rem;
  }

  @media (max-width: 1800px) {
      font-size: 2.2rem;
  }

  @media (max-width: 1420px) {
      font-size: 1.5rem;
  }

  @media (max-width: 1250px) {
    font-size: 1.2rem;
  }

  @media (max-width: 1110px) {
      font-size: 1rem;
  }

  @media (max-width: 960px) {
    font-size: 0.8rem;
  }

  @media (max-width: 850px) {
    font-size: 0.5rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 1.3rem;
  }  
`
export const TotalMinted = styled.div`
  display: flex;
  grid-column: 1;
  grid-row: 12 / 14;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin: 0;

  @media (max-width: 3300px) {
    font-size: 2.8rem;
  }

  @media (max-width: 1800px) {
      font-size: 2.2rem;
  }

  @media (max-width: 1420px) {
      font-size: 1.6rem;
  }

  @media (max-width: 1250px) {
    font-size: 1.3rem;
  }

  @media (max-width: 1110px) {
      font-size: 1rem;
  }

  @media (max-width: 850px) {
    font-size: 0.8rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 1.5rem;
  }
`

export const FiguresContainer = styled.div`
  // border: 5px dashed lime;
  display: grid;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  width: 100%;
  grid-column: 3;
  grid-row: 2 / 18;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
`

export const FiguresImg = styled.img`
  object-fit: scale-down;
  max-width: 23vw;
  max-height: 100%;
  margin: 0;
`
